import type { ContainerStatus } from '@xver/apis/v1/kufer/containers/model';

const STATUS_STYLES: Record<ContainerStatus, { label: string; color: string; bg: string }> = {
    pending: {
        label: 'Pending',
        color: 'var(--color-status-neutral)',
        bg: 'rgba(115, 115, 115, 0.2)',
    },
    building: {
        label: 'Building',
        color: 'var(--color-status-warning)',
        bg: 'rgba(251, 191, 36, 0.15)',
    },
    deploying: {
        label: 'Deploying',
        color: 'var(--color-status-info)',
        bg: 'rgba(96, 165, 250, 0.15)',
    },
    running: {
        label: 'Running',
        color: 'var(--color-status-success)',
        bg: 'rgba(34, 197, 94, 0.15)',
    },
    failed: { label: 'Failed', color: 'var(--color-status-danger)', bg: 'rgba(239, 68, 68, 0.15)' },
    stopped: {
        label: 'Stopped',
        color: 'var(--color-status-neutral)',
        bg: 'rgba(115, 115, 115, 0.2)',
    },
};

interface ContainerStatusBadgeProps {
    status: ContainerStatus;
    label?: string;
}

export default function ContainerStatusBadge({ status, label }: ContainerStatusBadgeProps) {
    const style = STATUS_STYLES[status] ?? STATUS_STYLES.pending;
    return (
        <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium"
            style={{ color: style.color, backgroundColor: style.bg }}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: style.color }} />
            {label ?? style.label}
        </span>
    );
}
